
/* ===== VELANTIS_SOCIAL — prueba social por producto en la vista rápida ===== */
(function(){
  var ov=document.getElementById('pvOverlay'); if(!ov) return;
  var nameEl=document.getElementById('pvName'),
      social=document.getElementById('pvSocial'),
      urg=document.getElementById('pvUrgency'),
      promo=document.getElementById('pvPromo');
  if(!social||!urg||!promo) return;

  // hash estable (FNV-1a) -> cada fragancia tiene siempre los mismos números
  function hash(s){var x=2166136261;for(var i=0;i<s.length;i++){x^=s.charCodeAt(i);x=Math.imul(x,16777619);}return x>>>0;}
  var SOLD=[500,650,800,1000,1300,1700,2200,3000];

  function fill(){
    var name=(nameEl.textContent||'').trim(); if(!name) return;
    var hv=hash(name);
    var rating=4.9;                 // 4.6 – 5.0
    var reviews=340;                   // 90 – 500 reseñas
    var sold=500;         // +vendidos por tramos
    var units=6;                 // quedan 3 – 12
    social.innerHTML=
      '<span class="pv-stars" aria-label="'+rating.toFixed(1)+' de 5 estrellas">★★★★★</span>'+
      '<span class="pv-rating-num">'+rating.toFixed(1)+'</span>'+
      '<span class="pv-reviews">('+reviews+' reseñas)</span>'+
      '<span class="pv-sold"><b>+'+sold+'</b> vendidos</span>';
    urg.innerHTML='<span class="dot"></span> Pocas unidades · quedan <b>'+units+'</b>';
    promo.innerHTML=
      '<span class="promo"><span class="tag">3×2</span> <b>por tiempo limitado</b></span>'+
      '<span class="promo"><span class="tag">4×3</span> <b>en toda la colección</b></span>';
  }

  new MutationObserver(function(){
    if(ov.classList.contains('show')) fill();
  }).observe(ov,{attributes:true,attributeFilter:['class']});
})();
